import { memo } from 'react'
import Checkbox from '../../Checkbox'
import ExpandableSectionTitle from '../../ExpandableComponent/ExpandableSectionTitle'

import styles from '../GenericDropdownMenu.module.scss'

interface GroupTitleProps {
  status: 'all' | 'some' | 'none'
  groupName: string
  isExpanded: boolean
  values: readonly string[]
  setExpanded: (expanded: boolean) => void
  toggleGroup: (group: readonly string[]) => () => void
}

const GroupTitle = ({
  status,
  groupName,
  isExpanded,
  values,
  setExpanded,
  toggleGroup
}: GroupTitleProps) => {
  return (
    <div className={styles.groupTitle} data-testid={`column-${groupName}`}>
      <Checkbox
        locator={`column-${groupName}-group`}
        checked={status === 'all'}
        indeterminate={status === 'some'}
        onChange={toggleGroup(values)}
      />
      <ExpandableSectionTitle isExpanded={isExpanded} setExpanded={setExpanded}>
        {groupName}
      </ExpandableSectionTitle>
    </div>
  )
}

export default memo(GroupTitle)
